import script from "./recommend.vue?vue&type=script&setup=true&lang=js"
export * from "./recommend.vue?vue&type=script&setup=true&lang=js"

import "./recommend.vue?vue&type=style&index=0&id=7f0f8285&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/qpyx-korea-gm/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f0f8285"]])

export default __exports__